import React from 'react';
import { CTAButton } from '../CTAButton';
import { contentBlocks } from '../../data/content';
export function ContentSystem() {
  return <section className="w-full bg-white px-4 py-14" aria-labelledby="contenido" data-id="element-115" data-mp="3ha8qzwerxwcj">
      <div className="mx-auto w-full max-w-4xl" data-id="element-116" data-mp="33ikis47nbs0u">
        <p className="text-center text-xs font-extrabold uppercase tracking-[0.25em] text-brandred" data-id="element-117" data-mp="37kxowtqb1ry5">
          Contenido
        </p>
        <h2 id="contenido" className="mt-3 text-center font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-118" data-mp="2tkwlb6ino6ez">
          Todo lo que necesitas para manejar la hipertensión de principio a fin,
          en un solo sistema
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-119" data-mp="2oltkjy9pkmct">
          No tendrás que saltar entre artículos, guías y apuntes. Ruta Hipertensión
          organiza todo el proceso clínico en un recorrido lógico para que siempre
          sepas cuál es el siguiente paso.
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-120" data-mp="708h2i30ic7q">
          {contentBlocks.map(block => <article key={block.title} className="rounded-3xl border border-navy/10 bg-cream p-5 transition-shadow hover:shadow-lg" data-id="element-121" data-mp="215ovy84s0h6">
              <span className="text-2xl" aria-hidden="true" data-id="element-122" data-mp="brgr9gc621ly">
                {block.emoji}
              </span>
              <h3 className="mt-3 text-lg font-extrabold text-navy" data-id="element-123" data-mp="3k70hs7lgd5xb">
                {block.title}
              </h3>
              <p className="mt-2 text-[15px] leading-snug text-navy/70" data-id="element-124" data-mp="3fa0kal2o5bht">
                {block.text}
              </p>
            </article>)}
        </div>

        <div className="mt-8" data-id="element-125" data-mp="3p6derl61ftdm">
          <CTAButton label="Quiero todo el sistema clínico" data-id="element-126" data-mp="3p63nlu99bg6c" />
        </div>
      </div>
    </section>;
}